import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";
import { api, money } from "../../lib/api";

export const copyLink = (link, who) => navigator.clipboard.writeText(link).then(() => toast.success(`Verification link for ${who || "buyer"} copied. Send it to them now`));

export const SalesNudge = () => {
  const [d, setD] = useState(null);
  const last = useRef(null);
  const { pathname } = useLocation();
  useEffect(() => {
    const load = () => api.get("/sales/scoreboard").then(({ data }) => {
      if (last.current && data.latest_sale_id && data.latest_sale_id !== last.current) {
        const s = data.feed[0];
        toast(s.protected ? `New sale protected: ${s.customer} · ${money(s.amount)}` : `New sale: ${s.customer} · ${money(s.amount)}, not protected yet`, {
          duration: 15000, description: s.protected ? "+10 XP" : "Send their verification link now to lock in proof of purchase.",
          action: s.link ? { label: "Copy link", onClick: () => copyLink(s.link, s.customer) } : undefined });
      }
      last.current = data.latest_sale_id;
      setD(data);
    }).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  if (!d?.unprotected?.length || pathname === "/app/sales") return null;
  const today = d.unprotected.filter((u) => String(u.date).slice(0, 10) === new Date().toISOString().slice(0, 10)).length;
  return (
    <Link to="/app/sales" className="flex items-center gap-3 mb-4 px-4 py-2.5 border border-[#FFB800]/50 bg-[#FFB800]/[0.07] hover:bg-[#FFB800]/[0.12] transition-colors" data-testid="sales-nudge-banner">
      <ShieldAlert className="w-4 h-4 text-[#FFB800] shrink-0" />
      <span className="text-sm flex-1"><b className="text-[#FFB800]">{d.unprotected.length} sale{d.unprotected.length > 1 ? "s" : ""} ({money(d.at_risk)}) unprotected</b>{today ? ` · ${today} from today` : ""}. No video proof means no defense if they dispute.</span>
      <span className="font-mono text-[10px] tracking-widest text-[#FFB800]">PROTECT NOW →</span>
    </Link>
  );
};
